import { navigateTo } from '../../common/frontend/route-utils.js'
import { catchAllRoute } from '../../common/frontend/route-utils.js'
import { t } from '../../common/i18n.js'
import { getBaseProps } from '../props/base.js'
import { View } from '../types.js'
import { NotFound, NotFoundProps } from '../views/not-found/not-found.js'

class NotFoundModel {
    public route = catchAllRoute<View>({
        render: (view) => <NotFound {...this.getProps(view)} />,
    })

    private getProps(view: View): NotFoundProps {
        const { lang } = view.state

        return {
            base: getBaseProps(view),
            title: t.notFound.title(lang),
            message: t.notFound.message(lang),
            homeButton: {
                text: t.notFound.goHome(lang),
                variant: 'primary',
                onClick: () => navigateTo('/'),
            },
        }
    }
}

export const notFoundModel = new NotFoundModel()
